/**
 * Content of the proxy gift card form.
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_sections/FormRenderer.tsx
 * Created:       Tue Jan 07 2025
 * Modified By:   Greg Olive
 * Last Modified: Tue Apr 22 2025
 */

import React, { useContext, useState } from 'react';
import { FormContext } from "@proxy/_contexts";
import { useGiftCardPreviewManager } from '@root/_hooks';
import FormWrapper from "./FormWrapper";
import {
  ClassicTheme,
  CrispTheme,
  EmbedTheme,
  SimpleTheme,
} from "../_themes";

type FormRendererProps = {
  bulkTranslations: any;
};

const FormRenderer = ({
  bulkTranslations,
}: FormRendererProps) => {
  
  const {
    loading,
    preview,
    settings,
    formData,
    bulkOrder,
    giftCardCost,
    fulfillmentType,
  } = useContext(FormContext);
  
  const {
    previewData
  } = useGiftCardPreviewManager({ formData, settings, giftCardCost, preview, fulfillmentType, bulkOrder });

  const [previewVisible, setPreviewVisible] = useState(false);

  const togglePreview = () => {
    setPreviewVisible(!previewVisible);
  };

  const formTheme = (typeof settings?.global?.appearance?.form_theme === 'string') ? settings.global.appearance.form_theme : "classic";

  const renderFormContent = () => {

    switch (formTheme) {
      case "simple":
        return (
          <SimpleTheme
            previewVisible={previewVisible}
            previewData={previewData}
            bulkTranslations={bulkTranslations}
            togglePreview={togglePreview}
          />
        );
      case "crisp":
        return (
          <CrispTheme
            previewData={previewData}
            bulkTranslations={bulkTranslations}
            togglePreview={togglePreview}
          />
        );
      case "product_template":
        return (
          <EmbedTheme
            togglePreview={togglePreview}
          />
        );
      default:
        return (
          <ClassicTheme
            previewVisible={previewVisible}
            previewData={previewData}
            bulkTranslations={bulkTranslations}
            togglePreview={togglePreview}
          />
        );
    }

  };

  return (
    <FormWrapper
      formTheme={formTheme}
    >
      {(!loading) ? renderFormContent() : null}
    </FormWrapper>
  );
};

export default FormRenderer;
